module.exports = __webpack_public_path__ + "img/chinesecompany67.25045bfe.png";